module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-57x57.png";